/**
 * Editorial content for the IPO Calendar page (/ipo-calendar): FAQs. The
 * calendar itself is built from the IPO APIs.
 */

export const CALENDAR_FAQS = [
  {
    question: 'What is the standard IPO bidding window duration in India?',
    answer:
      'Mainboard and SME IPOs normally stay open for three working days, excluding exchange holidays and weekends. When market conditions change, the issuer can extend the window by at least three more working days.',
  },
  {
    question: 'How does the T+1 / T+3 allotment and listing cycle work?',
    answer:
      "Under SEBI's shortened timeline, the basis of allotment is finalised one working day after the issue closes (T+1). Blocked ASBA funds are released and shares are credited to demat accounts by T+2, and the shares list on the exchange on T+3.",
  },
  {
    question: 'How can I sync these IPO dates to my Google Calendar?',
    answer:
      'Use "Sync All" above the calendar, or the "Sync" button next to any event. Both download an iCal (.ics) file you can import into Google, Apple or Outlook calendars. Closing-day entries include a reminder two hours before the 5:00 PM bidding cut-off.',
  },
];
